<div class="display-flex">
    <div class="col-md-6">
        <h4 mat-dialog-title>WARC Preview
            <span class="ml-3"><a *ngIf="fileSource" [href]="fileSource" [download]="'download'"><i
                        style="font-size: 18px;" class="mdi mdi-download"></i></a></span>
        </h4>
    </div>
    <div class="col-md-6 text-right p-4">
        <a href="javascript:" mat-dialog-close><i class="fa fa-times-circle text-secondary"></i></a>
    </div>
</div>
<mat-dialog-content class="mat-typography" style="overflow:hidden;">
    <div style="height: 390px;">
        <replay-web-page source="{{fileSource}}" embed="replayonly" replayBase="./assets/"
            view="pages"></replay-web-page>
    </div>
</mat-dialog-content>